import React from 'react';
import { FormGroup } from '../../form/group/index';
import { Input } from '../../form/input/index';
import { Button } from '../../button/index';
import { FaBars, FaTrashAlt, FaCopy } from 'react-icons/fa';
import InputMask from 'react-input-mask';
import { InputBox } from '../../form/input.box/index';
import { Tooltip } from '../../tooltip/index';
import { Checkbox } from '../../form/checkbox';
import { arrayMove, SortableContainer, SortableElement, SortableHandle } from 'react-sortable-hoc';
import { SCHEDULE_DATE_MAX, SCHEDULE_DATE_MIN, sanitizeScheduleDateInput, sanitizeScheduleTimeInput, } from '@lib/common';
const emptySlot = () => ({
    fromDate: '',
    toDate: '',
    open: '09:00',
    close: '17:00',
    h24: false,
});
const DragHandle = SortableHandle(() => (React.createElement(InputBox, { className: "no-round width40 cursor-move flex-center" },
    React.createElement("p", { className: "big font-bold" },
        React.createElement(FaBars, null)))));
const SortableItem = SortableElement((props) => {
    const { itemIndex, itemsLength, change, patch, copy, remove, allowNone } = props;
    const slot = props.item;
    const toDate = slot.toDate || slot.fromDate;
    return (React.createElement("div", { key: itemIndex, className: "flex-line m-b-2", style: { alignItems: 'flex-end' } },
        React.createElement(DragHandle, null),
        React.createElement("div", { className: "flex-line", style: { alignItems: 'flex-end' } },
            React.createElement(FormGroup, { className: "m-b-0", no_border: true },
                React.createElement(Input, { type: "date", className: "no-round", style: { width: '130px', minWidth: '130px' }, value: slot.fromDate || '', min: SCHEDULE_DATE_MIN, max: SCHEDULE_DATE_MAX, onChange: (e) => {
                        const raw = e.target.value;
                        if (!raw) {
                            patch(itemIndex, { fromDate: '', toDate: '' });
                            return;
                        }
                        const fromDate = sanitizeScheduleDateInput(raw);
                        if (!fromDate)
                            return;
                        patch(itemIndex, {
                            fromDate,
                            toDate: !slot.toDate || slot.toDate < fromDate ? fromDate : slot.toDate,
                        });
                    }, required: true })),
            React.createElement(FormGroup, { className: "m-b-0", no_border: true },
                React.createElement(Input, { type: "date", className: "no-round", style: { width: '130px', minWidth: '130px' }, value: toDate, min: slot.fromDate || SCHEDULE_DATE_MIN, max: SCHEDULE_DATE_MAX, onChange: (e) => {
                        const raw = e.target.value;
                        if (!raw) {
                            change(itemIndex, 'toDate', slot.fromDate || '');
                            return;
                        }
                        const toDateValue = sanitizeScheduleDateInput(raw);
                        if (!toDateValue)
                            return;
                        change(itemIndex, 'toDate', toDateValue);
                    }, required: true })),
            React.createElement(FormGroup, { className: "m-b-0", no_border: true },
                React.createElement(InputMask, { mask: "99:99", value: slot.open, onChange: (e) => change(itemIndex, 'open', sanitizeScheduleTimeInput(e.target.value)), disabled: slot.h24 }, (inputProps) => (React.createElement(Input, { type: "text", className: "no-round", style: { width: '100px', minWidth: '100px' }, placeholder: "00:00", ...inputProps, disabled: slot.h24 })))),
            React.createElement(FormGroup, { className: "m-b-0", no_border: true },
                React.createElement(InputMask, { mask: "99:99", value: slot.close, onChange: (e) => change(itemIndex, 'close', sanitizeScheduleTimeInput(e.target.value)), disabled: slot.h24 }, (inputProps) => (React.createElement(Input, { type: "text", className: "no-round", style: { width: '100px', minWidth: '100px' }, placeholder: "00:00", ...inputProps, disabled: slot.h24 })))),
            React.createElement(FormGroup, { className: "m-b-0", no_border: true },
                React.createElement(InputBox, { className: "no-round flex-center width75" },
                    React.createElement(Checkbox, { id: `${itemIndex}-date-range-24h-checkbox`, checked: slot.h24, onChange: (e) => change(itemIndex, 'h24', e.target.checked) })))),
        (allowNone || itemsLength !== 1) && (React.createElement(Tooltip, { text: "Delete", width: 65, position: "top", disable: itemIndex !== 0 },
            React.createElement(Button, { type: "button", className: "no-round", paddinglr: 5, color: "white", onClick: () => remove(itemIndex) },
                React.createElement(FaTrashAlt, null)))),
        React.createElement(Tooltip, { text: "Copy", width: 65, position: "top", disable: itemIndex !== 0 },
            React.createElement(Button, { type: "button", className: "no-round", paddinglr: 5, color: "white", onClick: () => copy(itemIndex) },
                React.createElement(FaCopy, null)))));
});
const SortableItemContainer = SortableContainer((props) => (React.createElement("div", null, props.items.map((item, i) => (React.createElement(SortableItem, { key: item._id || `date-range-${i}`, index: i, item: item, itemIndex: i, itemsLength: props.items.length, change: props.change, patch: props.patch, remove: props.remove, copy: props.copy, allowNone: props.allowNone }))))));
export class FieldDateRangeHours extends React.Component {
    add = () => {
        this.props.onChange([...(this.props.slots || []), emptySlot()]);
    };
    copy = (i) => {
        const slots = [...this.props.slots];
        slots.push({ ...slots[i] });
        this.props.onChange(slots);
    };
    remove = (i) => {
        const slots = [...this.props.slots];
        slots.splice(i, 1);
        this.props.onChange(slots);
    };
    change = (i, key, value) => {
        this.patch(i, { [key]: value });
    };
    patch = (i, patch) => {
        const slots = [...this.props.slots];
        slots[i] = { ...slots[i], ...patch };
        this.props.onChange(slots);
    };
    onSortEnd = ({ oldIndex, newIndex }) => {
        this.props.onChange(arrayMove(this.props.slots, oldIndex, newIndex));
    };
    render() {
        const { slots, allowNone } = this.props;
        const items = slots || [];
        if (items.length === 0) {
            return (React.createElement(Button, { color: "primary-inverse", size: "xs", type: "button", onClick: this.add }, "Add Time Slot"));
        }
        return (React.createElement("div", null,
            React.createElement(Button, { type: "button", size: "xs", color: "primary-inverse", className: "m-b-3", onClick: this.add }, "Add Time Slot"),
            React.createElement("div", { className: "flex-line m-b-2", style: { alignItems: 'flex-end' } },
                React.createElement("div", { style: { width: '40px', minWidth: '40px' } }),
                React.createElement("div", { className: "flex-line", style: { alignItems: 'flex-end' } },
                    React.createElement(FormGroup, { style: { width: '130px', minWidth: '130px' }, className: "m-b-0", title: "From", small_title: true, no_border: true }),
                    React.createElement(FormGroup, { style: { width: '130px', minWidth: '130px' }, className: "m-b-0", title: "To", small_title: true, no_border: true }),
                    React.createElement(FormGroup, { style: { width: '100px', minWidth: '100px' }, className: "m-b-0", title: "Start", small_title: true, no_border: true }),
                    React.createElement(FormGroup, { style: { width: '100px', minWidth: '100px' }, className: "m-b-0", title: "End", small_title: true, no_border: true }),
                    React.createElement(FormGroup, { style: { width: '75px', minWidth: '75px' }, className: "m-b-0", title: "24 Hour", small_title: true, no_border: true })),
                React.createElement("div", { style: { width: '40px', minWidth: '40px' } }),
                React.createElement("div", { style: { width: '40px', minWidth: '40px' } })),
            React.createElement(SortableItemContainer, { helperClass: "zindex-100 bsl-2", pressDelay: 50, useDragHandle: true, items: items, change: this.change, patch: this.patch, copy: this.copy, remove: this.remove, onSortEnd: this.onSortEnd, allowNone: allowNone || false })));
    }
}
//# sourceMappingURL=index.js.map